import { render } from "./tech-specs.vue?vue&type=template&id=efde79d8"
import script from "./tech-specs.vue?vue&type=script&lang=js"
export * from "./tech-specs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__